import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavbarService } from '../shared/services/navbar.service';
import { QuotesService } from '../shared/services/quotes.service';
import { UserService } from '../shared/services/user.service';
import { UtilsService } from '../shared/services/utils.service';
import { CountryGuideService } from '../shared/services/countryGuide.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-quote-estimator',
  templateUrl: './quote-estimator.component.html',
  styleUrls: ['./quote-estimator.component.scss']
})
export class QuoteEstimatorComponent implements OnInit {

  activeiconcolor=""
  asssignmentLabelPlural="";
  selectedServiceName="";
  selectedService=0;
  ShowEOREstimator = false;
  WorkersLabel="";
  quoteFormatVersion:any = null;


  quoteEstimatorForm = {};
  ShowQuoteEstimate = false;
  isLoading = true;
  ShowDetails = false;
  EORDisabled = null; 
  IsPartnerQuoteFormat = true;
  showPricing = false;
  ShowCalculatingPanel = false;
  ShowErrorPanel = false;
  ShowIncommpleteErrorPanel = false;

  ShowEmployerBurden = false;
  selectedCurrency={
    ID:null,
    Name:null
  }
  selectedPayRateType={
    ID:null,
    Name:null
  }
  FormData = {
    selectedCountry:null,
    pay_rate:"",
    selectedCurrency:null,
    selectedPayRateType:null,
    weekly_hours:null
  };

  showRegions = true;
  allowEndClients = null;
  showCompliance = null;    
  state = {
    service:1,
    global_scope:2
  };
  quote:any = null;
  quoteId = "7b57522b-d0d6-403c-b524-1f0e2f24003c";
  jobDescriptionFileID = "";
  EntityCurrencyCode:any = null;
  countryGuide:any = null;

  USEORDisabled = null;
  USComplianceDisabled = null;
  USAORDisabled = null;
  InternationalEORDisabled = null;
  InternationalComplianceDisabled = null;
  InternationalAORDisabled = null;

  ShowQuotesButton = false;
  ShowEngageButton = false;

  Hposition:MatSnackBarHorizontalPosition = "right";
  VPosition:MatSnackBarVerticalPosition = "top";
  

  ComplianceDisabled = false;
  AORDisabled = false;

  ShowEORQuotes = true;
  ShowComplianceQuotes = true;
  ShowAORQuotes = true;

  constructor(private nav:NavbarService,
    private userService:UserService,
    private activatedRoute: ActivatedRoute,
    private utils:UtilsService,
    private quoteService: QuotesService,
    private countryGuidService:CountryGuideService,
    private toast:MatSnackBar
  ) { }

  ngOnInit(): void {
    this.FormData.selectedCountry = -1;
    this.isLoading = true;
    this.activatedRoute.queryParams.subscribe(params => {
      Object.assign(this.state,params);
      this.state.service = parseInt(params.service || 1); 
      this.selectedServiceName = this.utils.getServiceName(this.state.service);
    });
    this.nav.show();
    this.nav.setActiveMenu('services');
    this.nav.setActiveModuleMenu({'isVisible':true, 'activeMenu':'services'});
    this.EORDisabled = this.userService.getEORDisabled();
    
    if (this.userService.getEOREstimatorAccess() && this.userService.getRole() !== 'Worker') {
      this.ShowEOREstimator = true;
    } else {
      this.ShowEOREstimator = false;
    }

    if(this.userService.getRole() == 'Worker') {
      this.ShowEORQuotes = false;
      this.ShowComplianceQuotes = false;
      this.ShowAORQuotes = false;
    }

    this.allowEndClients = this.userService.getAllowEndClients();
    this.showCompliance = !this.userService.getEvaluateButtonDisabled();
    
    this.quoteService.getQuotesById(this.quoteId)
    .subscribe(
      quote=>{        
        this.isLoading = false;
        if(quote.apiCallStatus !=1 || !quote.data.Data){
          return;
        }
        this.quote = quote.data.Data;

        this.selectedServiceName = this.utils.getServiceName(this.state.service);
        if (this.selectedServiceName == 'Employer of Record') {
            this.asssignmentLabelPlural = 'Assignments';
            this.WorkersLabel = 'Workers';
        }
        else if (this.selectedServiceName == 'Agent of Record') {
          this.asssignmentLabelPlural = 'Engagements';
            this.WorkersLabel = 'Engagements';
        }
        else if (this.selectedServiceName == 'Compliance') {
            this.asssignmentLabelPlural = 'Evaluations';
            this.WorkersLabel = 'Evaluations';
        }
        if (this.quote && this.quote !== null) {
          this.EntityCurrencyCode = this.quote?.QuoteRequest_EntityCurrency_Abbreviation;
          this.showPricing = (this.quote?.QuoteStatusName == 'Ready' || this.quote?.QuoteStatusName == 'Expired') ? true : false;
          if (this.quote?.QuoteRequest_Country_Abbreviation == 'US') {
            this.ShowDetails = false;
            //$scope.Compliance = true;
          }
          else if (this.quote?.QuoteRequest_Service_ServiceTypeEnumID == 3) {
            this.ShowDetails = false;
            //this.Compliance = true;
          }
          else {
            this.ShowDetails = true;
            //$scope.Compliance = false;
          }

          this.ShowEmployerBurden = true;
          if (this.quote?.QuotePricing_EmployerBurdenPercent == 0) {
            this.ShowEmployerBurden = false;
          }

          var quoteDate = new Date(this.quote?.QuotePricing_QuoteDate);
          var quoteFormatDate = new Date(this.userService.getNewQuoteFormatEffectiveDate());
          this.quoteFormatVersion = (quoteDate >= quoteFormatDate) ? 2 : 1;
          if (this.quote?.QuotePricing_QuoteDate == null) {
            this.quoteFormatVersion = 2;
          }

          this.jobDescriptionFileID = this.quote?.QuoteRequest_JobDescriptionFile_ID;
            if (this.quote?.QuotePricing_IsPartnerQuoteFormat == 0)
            {
            this.IsPartnerQuoteFormat = false;            
          }
          if (this.quote?.QuotePricing_IsPartnerQuoteFormat == 1) {
            this.IsPartnerQuoteFormat = true;           
          }

            if (this.quote?.QuoteRequest_Region_Name == null)
            {
            this.countryGuidService.getCountryGuidesDetail(this.quote.QuoteRequest_Country_ID,'null')
              .subscribe(countryGuide => {
                if(countryGuide.apiCallStatus != 1){
                  return;
                }
                this.countryGuide = countryGuide.data.Data;
              });
          }
            else
            {
            this.countryGuidService.getCountryGuidesDetail(this.quote.QuoteRequest_Country_ID, this.quote.QuoteRequest_Region_ID)
              .subscribe(countryGuide => {
                if(countryGuide.apiCallStatus != 1){
                  return;
                }
                this.countryGuide = countryGuide.data.Data;
              });
          }
        }
        else {
          this.ShowDetails = true;
          this.quoteFormatVersion = 2;
        }
      }
    );
    this.USEORDisabled = this.userService.getUSEORDisabled();
    this.USComplianceDisabled = this.userService.getUSComplianceDisabled();
    this.USAORDisabled = this.userService.getUSAORDisabled();
    this.InternationalEORDisabled = this.userService.getInternationalEORDisabled();
    this.InternationalComplianceDisabled = this.userService.getInternationalComplianceDisabled();
    this.InternationalAORDisabled = this.userService.getInternationalAORDisabled();

    this.ShowQuotesButton = !this.userService.getNewQuotesDisabled();
    this.ShowEngageButton = !this.userService.getNewEngageDisabled();

    this.ComplianceDisabled = this.userService.getComplianceDisabled();
    this.AORDisabled = this.userService.getAORDisabled();


  }
  
  submit(){
    this.ShowQuoteEstimate = false;
    this.ShowErrorPanel = false;
    this.ShowIncommpleteErrorPanel = false;
    if (!this.IsFormComplete()) {
      this.ShowIncommpleteErrorPanel = true;
      return;
    }
    this.ShowCalculatingPanel = true;
    let props = {};
    Object.assign(props, {
      country_id: this.FormData.selectedCountry.ID,
      //state_id: (this.FormData.selectedState != null) ? this.FormData.selectedState.ID : 0,
      state_id: 0,//Countrywide pricing for now
      weekly_hours: this.FormData.weekly_hours,
      pay_rate: this.FormData.pay_rate,
      currency_id: this.FormData.selectedCurrency.ID,
      pay_rate_type_id: this.FormData.selectedPayRateType.ID,
    });
    this.quoteService.estimate(props)
    .subscribe(
      (data:any)=>{
        if(data.apiCallStatus != 1 || !data.data.Data){
          this.ShowCalculatingPanel = false;
            this.toast.open("Unable to provide an estimate for this country. \n To get a Quote for a specific assignment, click 'Get a Quote'.", "Got it", {
            duration: 5000,horizontalPosition:this.Hposition,
            verticalPosition:this.VPosition,
            panelClass: 'iwg-toast-text-white',
          });
          return;
        } else{        
        let quote = data.data.Data;
        this.ShowCalculatingPanel = false;
        if (quote.QuoteRequest_EntityCurrency_Abbreviation == null) {
          this.ShowErrorPanel = true;
          return;
        }
        if (quote.QuotePricing_IsPartnerQuoteFormat == 0) {
          this.IsPartnerQuoteFormat = false;         
        }
        if (quote.QuotePricing_IsPartnerQuoteFormat == 1) {
            this.IsPartnerQuoteFormat = true;            
        }
        this.ShowErrorPanel = false;
        this.ShowIncommpleteErrorPanel = false;

        this.ShowQuoteEstimate = true;
        this.quote = quote;
        this.EntityCurrencyCode = quote.QuoteRequest_EntityCurrency_Abbreviation;

        this.showPricing = (quote?.QuoteStatusName == 'Ready' || quote?.QuoteStatusName == 'Expired') ? true : false;

        if (this.quote?.QuoteRequest_Country_Abbreviation == 'US') {
            this.ShowDetails = false;
            //this.Compliance = true;
        }
        else if (this.quote?.QuoteRequest_Service_ServiceTypeEnumID == 3) {
            this.ShowDetails = false;
            //this.Compliance = true;
        }
        else {
            this.ShowDetails = true;
            //this.Compliance = false;
        }

        this.ShowEmployerBurden = true;
        if (quote.QuotePricing_EmployerBurdenPercent == 0) {
            this.ShowEmployerBurden = false;
        }

        this.selectedServiceName = this.utils.getServiceName(this.state.service);
        if (this.selectedServiceName == 'Employer of Record') {
            this.asssignmentLabelPlural = 'Assignments';
            this.WorkersLabel = 'Workers';
        }
        else if (this.selectedServiceName == 'Agent of Record') {
            this.asssignmentLabelPlural = 'Engagements';
            this.WorkersLabel = 'Engagements';
        }
        else if (this.selectedServiceName == 'Compliance') {
            this.asssignmentLabelPlural = 'Evaluations';
            this.WorkersLabel = 'Evaluations';
        }
        var quoteDate = new Date(quote.QuotePricing_QuoteDate);
        var quoteFormatDate = new Date(this.userService.getNewQuoteFormatEffectiveDate());
        this.quoteFormatVersion = (quoteDate >= quoteFormatDate) ? 2 : 1;
        if (quote.QuotePricing_QuoteDate == null) {
            this.quoteFormatVersion = 2;
        }        
        if (quote.QuoteRequest_Region_Name == null)
        {
            this.countryGuidService.getCountryGuidesDetail(quote.QuoteRequest_Country_ID,'null')
            .subscribe(countryGuide => {
              if(countryGuide.apiCallStatus != 1){
                return;
              }
              this.countryGuide = countryGuide.data.Data;
            });
        }
        else
        {
            this.countryGuidService.getCountryGuidesDetail(quote.QuoteRequest_Country_ID, quote.QuoteRequest_Region_ID)
            .subscribe(countryGuide => {
              if(countryGuide.apiCallStatus != 1){
                return;
              }
              this.countryGuide = countryGuide.data.Data;
            });
        }
      }
      },
      err=>{
        this.toast.open("Error submitting form.", "Got it", {
          duration: 2000,horizontalPosition:this.Hposition,
          verticalPosition:this.VPosition,
          panelClass: 'iwg-toast-text-white',
        });
        console.log(err);
        return;
      }
    )
  }
  IsFormComplete() {    
    if
    (
        this.FormData.selectedCountry ==null ||
        this.FormData.selectedCountry == -1 ||
        this.FormData.pay_rate == null ||
        this.FormData.pay_rate == '' ||
        this.FormData.selectedCurrency == null ||
        this.FormData.selectedPayRateType == null
    )
    {
        return false;
    }

    if
    (
        this.FormData.selectedPayRateType.Name == 'Hour' &&
        (this.FormData.weekly_hours == null || this.FormData.weekly_hours =='')
    )
    {
        return false;
    }

    return true;
  }
  canProceed = () => {
    /*
      let valid = false;
      //require a region to be selected for countries that support regions.
      if ($scope.selectedCountry != null) {
          if ($scope.selectedState == null && $scope.selectedCountry.HasRegions == true && $scope.showRegions == true) {
              valid = false;
          }
      }
      return valid;
      */
      return true;
  };
  updateCountry(event){
    this.FormData.selectedCountry = event;
  }
  updatePayrate(event){
    this.FormData.selectedPayRateType = event;
  }
  updateCurrency(event){
    this.FormData.selectedCurrency = event;
  }
}
